import React from "react";
import {connect} from "react-redux";

import Permissioner from "utils/permissioner";
import {isInitialised} from "utils/uninitialised";
import setTitle from "utils/set_title";
import IssueOverrideTagList from "../components/issue_override_tag_list";
import {
  IssueOverrideTag,
  IssueOverrideTagId,
} from "common/types/issue_override_tag";
import {User} from "common/types/user";
import {OrganisationId} from "common/types/organisation";
import {bindActionCreators} from "redux";
import issueOverrideTagRemove from "modules/issue_override_tags/actions/remove";
import requestor from "requestor";
import issueOverrideTagUpdate from "modules/issue_override_tags/actions/update";

type Props = {
  user: User;
  issueOverrideTags: IssueOverrideTag[];
  removeIssueOverrideTag: (
    organisationId: OrganisationId,
    tagId: IssueOverrideTagId,
  ) => void;
  updateIssueOverrideTag: (
    organisationId: OrganisationId,
    tagId: IssueOverrideTagId,
    name: string,
  ) => void;
  params: {
    organisationId: string;
  };
};

function IssueOverrideTagsContainer(props: Props) {
  const shouldRenderContainer = isInitialised([
    props.user,
    props.issueOverrideTags,
  ]);

  if (!shouldRenderContainer || !props.user.permissions) {
    return <div />;
  }

  const permissioner = new Permissioner(props.user);
  if (
    !(
      permissioner.hasPermission("can-edit-issue-override-tags") ||
      permissioner.isAdmin()
    )
  ) {
    return permissioner.getNoPermissionMessage();
  }

  const organisationId = parseInt(props.params.organisationId, 10);

  const removeIssueOverrideTag = (tagId: IssueOverrideTagId) => {
    props.removeIssueOverrideTag(organisationId, tagId);
  };

  const updateIssueOverrideTag = async (
    tagId: IssueOverrideTagId,
    updatedName: string,
  ) => {
    return await props.updateIssueOverrideTag(
      organisationId,
      tagId,
      updatedName,
    );
  };

  setTitle("Issue Override Tags");
  return (
    <IssueOverrideTagList
      issueOverrideTags={props.issueOverrideTags}
      onDeleteTag={removeIssueOverrideTag}
      onEditTag={updateIssueOverrideTag}
    />
  );
}

function select(state) {
  return {
    user: state.user,
    issueOverrideTags: state.issueOverrideTags,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(
      {
        removeIssueOverrideTag: issueOverrideTagRemove(requestor),
        updateIssueOverrideTag: issueOverrideTagUpdate(requestor),
      },
      dispatch,
    ),
  };
}

export default connect(select, mapDispatchToProps)(IssueOverrideTagsContainer);
